import React from 'react';
import SpotDetailsDirectionsMap from './directions-map';
import SpotDetailsPanelMap from './mobile-map-preview';
import { parseDistance } from 'utils/travel-distance';
import useConfig from 'hooks/use-config';
export const FacilityLocation = ({ facility, walkingMeters, linearMeters, }) => {
    const { isMobile } = useConfig();
    const { latitude, longitude, airport: { details: { latitude: destinationLatitude, longitude: destinationLongitude, }, }, addresses, } = facility;
    // @ts-expect-error
    const distance = parseDistance({
        linearMeters,
        walkingMeters,
        format: 'long',
    });
    return (<div className="FacilityLocation">
            <h4 className="subtitle">Facility Location</h4>
            {isMobile ? (
        // @ts-expect-error
        <SpotDetailsPanelMap spotLatitude={latitude} spotLongitude={longitude} destinationLatitude={destinationLatitude} destinationLongitude={destinationLongitude} linearMeters={linearMeters} walkingMeters={walkingMeters} isDriving/>) : (
        //@ts-expect-error
        <SpotDetailsDirectionsMap spotLatitude={latitude} spotLongitude={longitude} destinationLatitude={destinationLatitude} destinationLongitude={destinationLongitude} linearMeters={linearMeters} walkingMeters={walkingMeters} isDriving isDraggable/>)}
            <div className="FacilityLocation-address-distance">
                <span className="address">{addresses[0].street_address}</span>
                <span className="distance">Driving Distance: {distance}</span>
            </div>
        </div>);
};
export default FacilityLocation;
